import { Component, OnInit } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';
import { EmployeeBO, IsViewEdit } from './employee.model';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss']
})
export class EmployeeComponent implements OnInit {

  EmployeeBO: EmployeeBO;
  ViewEdit: IsViewEdit = new IsViewEdit();
  isEdit: boolean = false;

  constructor(public global:GlobalComponent) {
    this.global.checkforlogout();
    
  }
  ngOnInit() {    
       if (this.global.globalemployee != "00000000-0000-0000-0000-000000000000") {
      this.isEdit = true;
      this.ViewEdit.isView = false;
      this.ViewEdit.isEdit = true;
      this.ViewEdit.isEditEmployee = true;
    }
    else {
      this.ViewEdit.isView = true;
      this.ViewEdit.isEdit = true;
      this.ViewEdit.isEditEmployee = false;
      this.ViewEdit.editEmployee = "";
      this.ViewEdit.Employeedata = new EmployeeBO();
    }
  }


  dataEmitfromChild(event: IsViewEdit) {    
    this.isEdit = event.isEdit;
    this.ViewEdit = event;
  }

}
